(function () {
	'use strict';

	angular.module('widgets.supplychain')
	.service('poToActionMonthlyService', poToActionMonthlyService);

	poToActionMonthlyService.$inject = ['$http', 'tableService'];

	function poToActionMonthlyService($http, tableService) {
		return {
			getChartData: getChartData
		};

		function getChartData(filterService) {
			var factoryNdxString = filterService.getFactoryList();
			var url = '/api/2/factndx/';
			url += factoryNdxString;
			url += '/PoToActionMonthly';
			url = addQueryParam(url,
				filterService.getFactoryList(), filterService.getQueryParamsObject(true), false);

			tableService.trackPageView('pos-to-action-next-12-months', factoryNdxString);

			return $http.get(url)
				.then(getChartDataComplete)
				.catch(getChartDataFailed);

			function getChartDataComplete(response) {
				return response.data;
			}
			function getChartDataFailed(error) {
				return error;
			}
		}
	}
})();
